export default __webpack_public_path__ + "growth.2cc81270.png";